module.exports = __webpack_public_path__ + "img/xinwen6.9a90d189.jpg";